// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`CustomInputGroup test Match con el snapshot 1`] = `""`;
